import { EngagementEnvelope } from "../net/envelope/engagement-envelope";

export class DialogableEngagementEnvelope extends EngagementEnvelope {
    public constructor(jsonEnvelope: any) {
        super(jsonEnvelope);
    }
    public isResourceChipSelectorDisabled: boolean = false;
    public isProductionChipSelectorDisabled: boolean = false;
}
